import i18n from "@/language/i18n";
import PROJECT_MANAGEMENT_WIDGETS from "./PROJECT_MANAGEMENT_WIDGETS";

const PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER = Object.freeze({
    INQUIRIES_MODULE_WINDOW_ID: 'inquiries',
    PROJECTS_MODULE_WINDOW_ID: 'projects',
    EXTERNAL_REPAIR_PROJECTS_MODULE: 'externalRepairProjects',
    INITIAL_ASSESSMENT_PROJECT_ASSIGNMENTS_MODULE_WINDOW_ID: 'initialAssessmentProjectAssignments',
    REPAIR_PROJECT_ASSIGNMENTS_MODULE_WINDOW_ID: 'repairProjectAssignments',
    QS_PROJECT_ASSIGNMENTS_MODULE_WINDOW_ID: 'qsProjectAssignments',
    PROJECT_WORKFLOW_MODULE_WINDOW_ID: 'projectWorkflow',
    PROCESS_DEVIATIONS_MODULE: 'deviations',
    VOS_PROJECTS_MODULE_WINDOW_ID: 'vosProjects',
    RENTAL_PROJECTS_MODULE: 'rentalRepairProjects',
    WARRANTY_PROJECTS_MODULE: 'warrantyRepairProjects',
    GOODWILL_PROJECTS_MODULE: 'goodwillRepairProjects',
    DISPOSAL_PROJECTS_MODULE: 'disposalRepairProjects',
});

export { PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER };

export default {
    PROJECT_MANAGMENT_GROUP_WRAPPER: {
        type: 'group',
        id: 'projectManagement',
        label: i18n.t('ModuleRegistry.groups.projectManagement.name'),
        children: [],
        icon: '$wPlanning',
        sidebarIcon: '$wNavProjectManagment'
    },
    CHILDREN: {
        INQUIRIES_MODULE: {
            type: 'module',
            id: 'projectInquiries',
            windowIdentifierType: PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER.INQUIRIES_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.projectManagement.projectInquiries.label'),
            navigationImg: require('@/assets/navigation/items/icon_projectanfragen.svg'),
            routerLink: '/inquiries',
            globalSearch: {
                index: "inquiries",
                presentation: i18n.t('ModuleRegistry.groups.projectManagement.projectInquiries.label'),
                component: "InquiryItem.vue",
                shortcut: "-i"
            },
            widgets: PROJECT_MANAGEMENT_WIDGETS.INQUIRY_WIDGETS
        },
        PROJECTS_MODULE: {
            type: 'module',
            id: 'projectsOverview',
            windowIdentifierType: PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER.PROJECTS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.projectManagement.projectsOverview.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/projects',
            globalSearch: {
                index: 'projects',
                presentation: i18n.t('ModuleRegistry.groups.projectManagement.projectsOverview.presentation'),
                component: 'ProjectItem',
                shortcut: '-p'
            },
            widgets: PROJECT_MANAGEMENT_WIDGETS.PROJECT_WIDGETS
        },
        EXTERNAL_REPAIR_PROJECTS_MODULE: {
            type: 'module',
            id: 'externalRepairProjectsOverview',
            windowIdentifierType: PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER.VOS_PROJECTS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.projectManagement.externalRepairProjectsView.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/projects-external-repair',
            globalSearch: {
                index: 'projects',
                presentation: i18n.t('ModuleRegistry.groups.projectManagement.externalRepairProjectsView.label'),
                component: 'ProjectItem',
                shortcut: '-p'
            },
            // widgets: PROJECT_MANAGEMENT_WIDGETS.VOS_PROJECT_WIDGETS
        },
        INITIAL_ASSESSMENT_PROJECT_ASSIGNMENTS_MODULE: {
            type: 'module',
            id: 'initialAssessmentProjectAssignments',
            windowIdentifierType: PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER.INITIAL_ASSESSMENT_PROJECT_ASSIGNMENTS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.projectManagement.initialAssessmentProjectAssignments.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/initial-assessment-project-assignments',
        },
        REPAIR_PROJECT_ASSIGNMENTS_MODULE: {
            type: 'module',
            id: 'repairProjectAssignments',
            windowIdentifierType: PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER.REPAIR_PROJECT_ASSIGNMENTS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.projectManagement.repairProjectAssignments.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/repair-project-assignments',
        },
        QS_PROJECT_ASSIGNMENTS_MODULE: {
            type: 'module',
            id: 'qsProjectAssignments',
            windowIdentifierType: PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER.QS_PROJECT_ASSIGNMENTS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.projectManagement.qsProjectAssignments.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/qs-project-assignments',
        },
        PROJECTS_WORKFLOW: {
            type: 'module',
            hidden: true,
            windowIdentifierType: PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER.PROJECT_WORKFLOW_MODULE_WINDOW_ID,
        },
        PROCESS_DEVIATIONS_MODULE: {
            type: 'module',
            id: 'deviations',
            label: i18n.t('ModuleRegistry.groups.projectManagement.processDeviations.label'),
            navigationImg: require('@/assets/navigation/items/icon_projectanfragen.svg'),
            routerLink: '/deviations'
        },
        VOS_PROJECTS_MODULE: {
            type: 'module',
            id: 'VOSProjectsOverview',
            windowIdentifierType: PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER.VOS_PROJECTS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.projectManagement.vosProjectsOverview.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/projects-vos',
            globalSearch: {
                index: 'projects',
                presentation: i18n.t('ModuleRegistry.groups.projectManagement.vosProjectsOverview.label'),
                component: 'ProjectItem',
                shortcut: '-p'
            },
            widgets: PROJECT_MANAGEMENT_WIDGETS.VOS_PROJECT_WIDGETS
        },
        RENTAL_PROJECTS_MODULE: {
            type: 'module',
            id: 'rentalProjectsOverview',
            windowIdentifierType: PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER.RENTAL_PROJECTS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.projectManagement.rentalProjectsView.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/projects-rental',
            globalSearch: {
                index: 'projects',
                presentation: i18n.t('ModuleRegistry.groups.projectManagement.rentalProjectsView.label'),
                component: 'ProjectItem',
                shortcut: '-p'
            },
            // widgets: PROJECT_MANAGEMENT_WIDGETS.VOS_PROJECT_WIDGETS
        },
        WARRANTY_PROJECTS_MODULE: {
            type: 'module',
            id: 'warrantyProjectsOverview',
            windowIdentifierType: PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER.WARRANTY_PROJECTS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.projectManagement.warrantyProjectsView.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/projects-warranty',
            globalSearch: {
                index: 'projects',
                presentation: i18n.t('ModuleRegistry.groups.projectManagement.warrantyProjectsView.label'),
                component: 'ProjectItem',
                shortcut: '-p'
            },
            // widgets: PROJECT_MANAGEMENT_WIDGETS.VOS_PROJECT_WIDGETS
        },
        GOODWILL_PROJECTS_MODULE: {
            type: 'module',
            id: 'goodwillProjectsOverview',
            windowIdentifierType: PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER.GOODWILL_PROJECTS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.projectManagement.goodwillProjectsView.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/projects-goodwill',
            globalSearch: {
                index: 'projects',
                presentation: i18n.t('ModuleRegistry.groups.projectManagement.goodwillProjectsView.label'),
                component: 'ProjectItem',
                shortcut: '-p'
            },
            // widgets: PROJECT_MANAGEMENT_WIDGETS.VOS_PROJECT_WIDGETS
        },
        DISPOSAL_PROJECTS_MODULE: {
            type: 'module',
            id: 'disposalProjectsOverview',
            windowIdentifierType: PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER.DISPOSAL_PROJECTS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.projectManagement.disposalProjectsView.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/projects-disposal',
            globalSearch: {
                index: 'projects',
                presentation: i18n.t('ModuleRegistry.groups.projectManagement.disposalProjectsView.label'),
                component: 'ProjectItem',
                shortcut: '-p'
            },
            // widgets: PROJECT_MANAGEMENT_WIDGETS.VOS_PROJECT_WIDGETS
        },
        TEMPLATE_MODULE: {
            type: 'module',
            id: 'projectsPreview',
            label: i18n.t('ModuleRegistry.groups.projectManagement.projectPreview.label'),
            navigationImg: require('@/assets/navigation/items/icon_projectanfragen.svg'),
            routerLink: '/preview',
            globalSearch: {
                index: 'preview',
                presentation: i18n.t('ModuleRegistry.groups.projectManagement.projectPreview.presentation'),
                component: 'TemplateItem',
            },
        },
    }
}
